import { Pipe, PipeTransform } from '@angular/core';
import { AppointmentLoadType } from '@services';

@Pipe({
    name: 'appointmentLoadType',
    standalone: true,
})
export class AppointmentLoadTypePipe implements PipeTransform {
    transform(value: AppointmentLoadType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case AppointmentLoadType.FloorLoad: return 'Floor Load';
            case AppointmentLoadType.Pallet: return 'Pallet';
            case AppointmentLoadType.SlipSheet: return 'Slip Sheet';
            case AppointmentLoadType.CHEP: return 'CHEP';
            case AppointmentLoadType.Returns: return 'Returns';
            default:
                return value;
        }
    }
}